import './loader.scss';

export default function Loader() {
  return (
    <div className="loader__container">
      <div className="loader"></div>
    </div>
  );
}
